import { businessService } from '@/pages/Business/services/business.service';
import type {
  ExportJobListResponse,
  ExportJobDetail,
  ExportJobsFilters,
} from '../models/ExportJob';

export interface GetExportJobsParams {
  filters: ExportJobsFilters;
  page: number;
  pageSize: number;
}

const exportJobsApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getExportJobs: builder.query<ExportJobListResponse, GetExportJobsParams>({
      query: ({ filters, page, pageSize }) => {
        const params: Record<string, string> = {
          limit: String(pageSize),
          offset: String((page - 1) * pageSize),
        };
        if (filters.status) params.status = filters.status;
        if (filters.exportKind) params.exportKind = filters.exportKind;
        if (filters.createdAtFrom) params.createdAtFrom = filters.createdAtFrom;
        if (filters.createdAtTo) params.createdAtTo = filters.createdAtTo;
        return { url: 'export-jobs', params };
      },
      providesTags: ['ExportJobs'],
    }),
    getExportJobDetail: builder.query<ExportJobDetail, string>({
      query: (jobId) => ({ url: `export-jobs/${jobId}` }),
      providesTags: (_result, _error, jobId) => [
        { type: 'ExportJobDetail' as const, id: jobId },
      ],
    }),
  }),
});

export const { useGetExportJobsQuery, useLazyGetExportJobDetailQuery } =
  exportJobsApi;
